import { render, staticRenderFns } from "./PickupDispatchCar.vue?vue&type=template&id=3b472efa&scoped=true&"
import script from "./PickupDispatchCar.vue?vue&type=script&lang=js&"
export * from "./PickupDispatchCar.vue?vue&type=script&lang=js&"
import style0 from "./PickupDispatchCar.vue?vue&type=style&index=0&id=3b472efa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b472efa",
  null
  
)

export default component.exports